import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AppPackage } from '../app.package';
import { OpenApiDataService } from '../services';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [OpenApiDataService],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  isMobile: boolean = false;
  currentYear = new Date().getFullYear();
  appVersion = AppPackage.devVersion;

  constructor(
    public breakpointObserver: BreakpointObserver,
  ) {
  }

  ngOnInit(): void {
    this.breakpointObserver
    .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium])
    .subscribe((state: BreakpointState) => {
      this.isMobile = state.matches;
    });
  }

  ngOnDestroy(): void {
  }

  ngAfterViewInit() {
  }

}
